
import Coureur from "../Coureurs/Coureur.class";
import UserService from "../../services/user.service";


/**
 * @classdesc La liste des coureurs d'un utilisateur
 * @kind class
 * @export
 * @prop {int} id_utilisateur - Id de l'utilisateur
 * @prop {Coureur[]} list - Liste des coureurs de l'utilisateur
 * @class List_Coureurs
 */
export default class List_Coureurs {
    id_utilisateur;
    list = [];
    /**
     * Creates an instance of List_Coureurs.
     * @constructs
     * @kind function
     * @memberof List_Coureurs
     */
    constructor() { }

    async fetch() {
        this.list = [];
        let res = await UserService.getCoureurs();
        this.set(res);
    }

    /**
     * Créer la liste des coureurs d'un utilisateur
     *
     * @param {array} data
     * @memberof List_Coureurs
     */
    set(data) {
        this.list = [];
        for (let i = 0; i < data.length; i++) {
            let coureur = new Coureur();
            coureur.set(data[i], true);
            this.list.push(coureur);
        }
    }
}